module.exports = __webpack_public_path__ + "media/images/close_x_white-0c63e46835c93beda7a4b23e09e0adbc.png";